var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.condicion)?[_vm._t("if")]:[_vm._t("else")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }